import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiArrowRight } from "react-icons/fi";

const bubbles = [
  "left-[6%] top-[72%] h-24 w-24",
  "left-[18%] top-[18%] h-12 w-12",
  "left-[31%] top-[76%] h-16 w-16",
  "left-[48%] top-[10%] h-28 w-28",
  "left-[63%] top-[70%] h-14 w-14",
  "left-[78%] top-[22%] h-20 w-20",
  "left-[90%] top-[66%] h-32 w-32",
  "left-[8%] top-[38%] h-10 w-10",
  "left-[56%] top-[44%] h-9 w-9",
];

export default function AboutCTA() {
  return (
    <>
      {/* CTA */}
      <section className="relative isolate overflow-hidden bg-gradient-to-r from-trogoBlue to-trogoOrange py-16 text-white sm:py-18">
        <div className="absolute inset-0 -z-30 bg-[radial-gradient(circle_at_20%_20%,rgba(255,255,255,0.18),transparent_26%),radial-gradient(circle_at_85%_15%,rgba(255,255,255,0.2),transparent_30%)]" />
        <div className="absolute inset-0 -z-20 bg-[linear-gradient(to_right,rgba(255,255,255,0.09)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.08)_1px,transparent_1px)] bg-[size:42px_42px] opacity-45" />

        {bubbles.map((className, index) => (
          <motion.span
            key={className}
            aria-hidden="true"
            className={`absolute -z-10 rounded-full border border-white/25 bg-white/10 shadow-[inset_0_1px_18px_rgba(255,255,255,0.35),0_20px_70px_rgba(15,23,42,0.16)] backdrop-blur-xl ${className}`}
            animate={{
              y: [0, -28 - index * 3, 0],
              x: [0, index % 2 === 0 ? 16 : -16, 0],
              scale: [1, 1.08, 1],
              opacity: [0.42, 0.8, 0.42],
            }}
            transition={{
              duration: 5.5 + index * 0.55,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        ))}

        <div className="relative mx-auto max-w-5xl px-6 text-center">
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.65, delay: 0.08, ease: "easeOut" }}
            className="mx-auto mt-5 max-w-4xl text-4xl font-black leading-[1.04] tracking-normal sm:text-5xl lg:text-6xl"
          >
            Ready to Join the Transport Revolution?
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.6, delay: 0.16, ease: "easeOut" }}
            className="mx-auto mt-5 max-w-3xl text-base leading-7 text-white/82 md:text-lg"
          >
            Experience the future of mobility. Download the app or get in touch
            to learn more about how TROGO is changing the game.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.6, delay: 0.24, ease: "easeOut" }}
            className="mt-8 flex flex-col justify-center gap-4 sm:flex-row"
          >
            <Link
              to="/contact"
              className="group inline-flex items-center justify-center gap-3 rounded-full bg-white px-8 py-4 font-bold text-trogoBlue shadow-[0_24px_60px_rgba(15,23,42,0.24)] transition hover:-translate-y-1 hover:shadow-[0_30px_70px_rgba(15,23,42,0.3)]"
            >
              Contact Us
              <FiArrowRight className="transition group-hover:translate-x-1" />
            </Link>
          </motion.div>
        </div>
      </section>
    </>
  );
}